<header class="topbar">
  <div class="topbar__left">
    @if (projectService.currentProject()) {
      <button
        class="topbar__menu-btn"
        aria-label="Toggle menu"
        (click)="menuToggle.emit()"
      >
        <span class="topbar__menu-icon">&#9776;</span>
      </button>
      <div class="topbar__project-selector">
        <span class="topbar__project-label">{{projectService.currentProject()?.projectName}}</span>
      </div>
    }
  </div>

  <div class="topbar__center">
    <img
      [tabindex]="0"
      class="topbar__logo"
      src="logos/anessa-digital-twin-logo.png"
      alt="Anessa Digital Twin"
      (click)="navigateToHome()"
      (keydown)="navigateToHome()"
    />
  </div>

  <div class="topbar__right">
    <div class="topbar__actions">
      <div class="topbar__lang-switcher">
        <button
          class="topbar__lang-btn"
          [class.topbar__lang-btn--active]="lang() === AVAILABLE_LANGUAGES.EN"
          (click)="setLanguage(AVAILABLE_LANGUAGES.EN)"
        >
          EN
        </button>
        <span class="topbar__lang-divider">|</span>
        <button
          class="topbar__lang-btn"
          [class.topbar__lang-btn--active]="lang() === AVAILABLE_LANGUAGES.FR"
          (click)="setLanguage(AVAILABLE_LANGUAGES.FR)"
        >
          FR
        </button>
      </div>
      <div class="topbar__user-box">
        <app-dropdown-menu></app-dropdown-menu>
      </div>
    </div>
  </div>
</header>
